import comp from "./SmallLibraryItem";
export default comp;
